// Events
export const EVENT_CLICKED_INVITE_BUTTON = 'Clicked Find Designer Invite Button';

// Designer levels
export const LEVEL_ENTRY = 'entry';
export const LEVEL_MID = 'mid';
export const LEVEL_TOP = 'top';



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/consts.ts